import {
  Badge,
  Divider,
  ListItemIcon,
  ListItemButton,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { prorateCalculator } from './constants';

const NavListIcon = ({ icon, sx, value, selected, notification }) => {
  const badgeColor = {
    // `secondary` is purple in the theme.
    'needs-help': 'secondary',
    new: 'error',
    unresolved: 'primary',
  }[notification];

  return (
    <>
      {value === prorateCalculator ? <Divider sx={{ marginY: 2 }} /> : null}
      <ListItemButton
        id={value}
        selected={selected}
        sx={{
          ...sx,
          height: 50,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon ? (
          <ListItemIcon
            sx={{
              pointerEvents: 'none',
              width: 'unset',
              minWidth: 'unset',
              display: 'unset',
            }}
          >
            {notification ? (
              <Badge variant="dot" color={badgeColor}>
                {icon}
              </Badge>
            ) : (
              icon
            )}
          </ListItemIcon>
        ) : null}
      </ListItemButton>
    </>
  );
};

export default NavListIcon;
